<form #form="ngForm" [ngClass]="{ forms: !exibirCampoTelefone }">
  <div class="form-group">
    <span class="icon professional-class"></span>
    <div class="inputs">
      <label for="user-occupation-class">Classe Profissional</label>
      <select
        name="classeProfissional"
        class="form-control"
        (change)="onChangeClasse()"
        [(ngModel)]="dadosProfissionais.classeProfissional"
        appShowErrorMessages
        [disabled]="isLoadingProfissao"
        required
        id="user-occupation-class"
        [compareWith]="compareByID"
      >
        <option [ngValue]="undefined" hidden>Selecione...</option>
        <option *ngFor="let cla of classes" [ngValue]="cla">
          {{ cla.descricao }}
        </option>
      </select>
    </div>
  </div>

  <div class="form-group">
    <span class="icon profession"></span>
    <div [ngSwitch]="isLoadingProfissao" class="inputs">
      <label for="user-occupation">Profissão</label>
      <select
        *ngSwitchDefault
        appShowErrorMessages
        id="user-occupation"
        name="profissao"
        class="form-control"
        (change)="onChange()"
        [(ngModel)]="dadosProfissionais.profissao"
        [disabled]="profissoes.length === 0"
        required
        [compareWith]="compareByID"
      >
        <option [ngValue]="undefined" hidden>Selecione...</option>
        <option *ngFor="let pro of profissoes" [ngValue]="pro">
          {{ pro.descricao }}
        </option>
      </select>
      <app-loader-default *ngSwitchCase="true"></app-loader-default>
    </div>
  </div>

  <div
    class="form-group"
    [ngClass]="{ 'dados-profissionais__hidden': !isPesados }"
  >
    <span class="icon"></span>
    <div class="inputs">
      <label for="experience-time">Tempo de Experiência</label>
      <select
        id="experience-time"
        class="form-control"
        name="tempoExperiencia"
        required
        appShowErrorMessages
        requiredMessage="Tempo de Experiência é obrigatório"
        [(ngModel)]="dadosProfissionais.tempoExperiencia"
        (ngModelChange)="onChange()"
        [disabled]="isLoadingTempoExperiencia"
      >
        <option [value]="{}" hidden selected>Selecione...</option>
        <option *ngFor="let tmpExp of listaTempoExperiencia" [ngValue]="tmpExp">
          {{ tmpExp.descricao }}
        </option>
      </select>
    </div>
  </div>

  <div
    class="form-group"
    [ngClass]="{ 'dados-profissionais__hidden': !isPesados }"
  >
    <span class="icon family-business"></span>
    <div class="inputs">
      <label for="user-expose">Possui familiares no ramo?</label>

      <div class="dados-profissionais__switch marginT10 check-mod">
        <app-switch
          #possuiFamiliaresRamo
          id="possuiFamiliaresRamo"
          (change)="setPossuiFamiliaresRamo($event)"
        >
        </app-switch>
        <label>
          <span class="radio-label">Sim</span>
        </label>

        <app-switch
          class="dados-profissionais__switch_button"
          #naoPossuiFamiliaresRamo
          id="naoPossuiFamiliaresRamo"
          (change)="setPossuiFamiliaresRamo($event)"
        >
        </app-switch>
        <label>
          <span class="radio-label">Não</span>
        </label>
      </div>
    </div>
  </div>

  <div
    *ngIf="dadosProfissionais?.classeProfissional?.empresa"
    class="form-group"
  >
    <span class="icon company"></span>
    <div class="inputs">
      <label for="user-work-company">Nome da Empresa</label>
      <input
        type="text"
        class="form-control"
        id="user-work-company"
        placeholder="Digite o nome da empresa..."
        appShowErrorMessages
        uppercase
        [appNomeEmpresa]="true"
        requiredMessage="Nome da empresa é obrigatório"
        maxlength="40"
        minlength="3"
        name="empresaCliente"
        [(ngModel)]="dadosProfissionais.empresa.nome"
        (ngModelChange)="onChange()"
        required
      />
    </div>
  </div>

  <div
    *ngIf="dadosProfissionais?.classeProfissional?.empresa"
    class="form-group"
  >
    <span class="icon company-phone"></span>
    <div class="inputs">
      <label for="user-work-company-phone">Celular da empresa</label>
      <input
        type="text"
        class="form-control"
        placeholder="(00) 00000-0000"
        appTelefone
        [minLength]="11"
        name="foneEmpresaCliente"
        [(ngModel)]="dadosProfissionais.empresa.telefone"
        (ngModelChange)="onChange()"
        appOnlyDigitsLengthValidator
        appShowErrorMessages
        invalidMessage="Telefone inválido"
        required
        genericErrorMessage
        appCelularValidator
        (focus)="clearErrorMessage('errorMessage')"
        [ngModelOptions]="{ updateOn: 'blur' }"
      />
      <div *ngIf="errorMessage" class="text-danger">
        {{ errorMessage }}
      </div>
    </div>
  </div>
</form>
